var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-form',{staticClass:"box",staticStyle:{"text-align":"center"}},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/console2.png")}})]),_vm._v(" "),_c('el-form',{staticClass:"box2",staticStyle:{"text-align":"center"}},[_c('h2',{staticClass:"welcome-prompt"},[_vm._v(_vm._s(_vm.$t("alexa.console_welcome_prompt")))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e4cf5e1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = null
// module chunks = 